import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Ortak } from './../../providers/ortak';
import { YonetimAnaSayfaPage } from './../Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { GirisPage } from './../giris/giris';
import { StoklarPage } from './../StokIslemleri/stoklar/stoklar';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { Component } from '@angular/core';
import { NavController,MenuController } from 'ionic-angular';
import { CarilerPage } from '../CariIslemleri/cariler/cariler';
import { PagesProvider } from '../../providers/pages-provider';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  lambdurum = false;
  kullaniciyetkiseviyesi: any;
  aktifKullanici: any;
  ureticigiris:any;
ToplamPalsan:any;
ToplamKasa:any;
ToplamKg:any;
  TamamlananisSayi: any;
  durumlistesi: any = {};
  timerSubscr: any;
  menuler = [];
  cariListesi : any = {ToplamKasa:"",ToplamPalsan:"",ToplamKg:""};
  gunSonu = false;
 
  constructor(public navCtrl: NavController,
    public menu: MenuController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
  ) {
    this.kullaniciyetkiseviyesi = this.ortak.storagePersonelGetir.Type;
    this.aktifKullanici = this.ortak.storagePersonelGetir.Name;
    this.ureticigiris=this.ortak.storagePersonelGetir.TCK;
    menu.enable(false);
    this.MenuleriGoruntule();
    this.ToplamSayilariGetir();
  }
  ionViewDidLoad() {
   
  }
  Carisayfasi() {
    this.navCtrl.push(CarilerPage)
  }
 

  StokSayfasi() {
    this.navCtrl.push(StoklarPage)
  }

  Cikis() {
    this.navCtrl.setRoot(GirisPage);
  }
  YonetimSayfasi() {
    this.navCtrl.push(YonetimAnaSayfaPage);
  }
 
ToplamSayilariGetir()
{
  var formData = new FormData();
  
  this.bllOrtak.islem(formData, "ToplamStokSayisi","", false).then(a => {
   
    var sonuc = <any>a;
    this.cariListesi = sonuc.SonucObject;
    this.ToplamPalsan=this.cariListesi.ToplamPalsan;
this.ToplamKasa=this.cariListesi.ToplamKasa;
this.ToplamKg=this.cariListesi.ToplamKg;

console.log("ToplamSayş",this.cariListesi)
})

}

  MenuleriGoruntule() {
    var pagesProvider = new PagesProvider();
    pagesProvider.menuler().then(a => {
      var sonuc = <any>a;
      if (this.kullaniciyetkiseviyesi == 2) {// Yönetici ise tüm menüleri yükle
        this.menuler = sonuc.MAIN_MENU;
      }
      else if (this.kullaniciyetkiseviyesi == 1) {// Kasiyer ise
        this.menuler = sonuc.KULLANICI_MENU;
      }
      else if(this.ureticigiris!=null) //URETİCİ İSE
      {
        this.menuler=sonuc.URETICI_MENU;
      }

    })
  }
  menuItemClick(item) {
    if (item.GUN_ISLEMI == true) {
      if (this.gunSonu == true) {
        this.ortak.showBasicAlert("UYARI", "İşleme devam edebilmek için gün başı yapmalısınız.");
        return;
      }
    }
    var pagesProvider = new PagesProvider();
    var componentType = typeof item.PAGE_COMPONENT;
    var component;
    if (componentType === "string")
      component = pagesProvider.components[item.PAGE_COMPONENT];
    else
      component = item.PAGE_COMPONENT;
    if (component == GirisPage) {
      //  this.ortak.storeagePersonelCikar();
    }
    this.navCtrl.push(component);
  }
  ionViewDidEnter() {
    let timer = TimerObservable.create(10000, 20000);
    this.timerSubscr = timer.subscribe(t => {
      this.ToplamSayilariGetir();
     
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts